import { createPortal } from 'react-dom';
import styled, { keyframes } from 'styled-components';
import { useModal } from '../../context/ModalProvider';

/* ────────── animation ────────── */
const appear = keyframes`
  0% { transform: scale(.8); opacity: 0; }
  60% { transform: scale(1.05); }
  100% { transform: scale(1); opacity: 1; }
`;

/* ────────── shell ────────── */
const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 80;
`;

const Panel = styled.div`
  width: 100%;
  max-width: 420px;
  background: ${({ theme }) => theme.colors.gray100};
  color: ${({ theme }) => theme.colors.gray700};
  border-radius: 24px;
  padding: 2rem;
  box-shadow: 0 8px 24px rgba(0,0,0,.2);
  animation: ${appear} .35s cubic-bezier(.22,1.44,.46,.99);
`;

/* ────────── component ────────── */
export default function ConnectIntegrationModal() {
  const { close } = useModal();

  return createPortal(
    <Backdrop onClick={close}>
      <Panel onClick={e => e.stopPropagation()}>
        <h3 style={{ marginTop: 0 }}>Connect an Integration</h3>

        {/* TODO: replace stub with real OAuth / API‑key form */}
        <p style={{ fontSize: '.9rem' }}>
          Select a platform and provide credentials or start the OAuth flow.
        </p>

        <div style={{ display:'flex', gap:'.75rem', marginTop:'1rem' }}>
          <button style={{ flex:1 }}>Reddit</button>
          <button style={{ flex:1 }}>Facebook</button>
        </div>

        <button
          onClick={close}
          style={{ marginTop:'2rem', width:'100%' }}
        >
          Close
        </button>
      </Panel>
    </Backdrop>,
    document.body
  );
}
